import { axios } from './axios.js';

// Fetch all projects and their tasks - used for grid view
export async function fetchProjectsAndTasks(organizationId = null) {
  const params = new URLSearchParams();
  if (organizationId) params.append('organizationId', organizationId);
  params.append('offset', 0);

  try {
    const response = await axios.get('/model-folder', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching model folders:', error);
    throw error;
  }
}

// projects
export async function fetchProjects(organizationId = null) {
  const params = new URLSearchParams();
  if (organizationId) params.append('organizationId', organizationId);
  params.append('offset', 0);

  try {
    const response = await axios.get('/model-folder/folderInfo', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching model folders:', error);
    throw error;
  }
}

export async function fetchProjectById(projectId) {
  try {
    const response = await axios.get(`/model-folder/folderInfo/${projectId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching project by ID:', error);
    throw error;
  }
}

export async function fetchProjectBySharingId(shortSharingId = null) {
  const params = new URLSearchParams();
  params.append('shortSharingId', shortSharingId);
  try {
    const response = await axios.get('/model-folder', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching project by ID:', error);
    throw error;
  }
}

export async function getProjectSharingId(projectId) {
  return axios
    .get(`/model-folder/getShortSharingId/${projectId}`)
    .then(res => res.data);
}

export async function renameProject(folderId, payload) {
  return axios
    .patch(`/model-folder/${folderId}`, payload)
    .then(res => res.data);
}

export async function saveProject(folderId, payload) {
  return axios
    .patch(`/model-folder/${folderId}/save`, payload)
    .then(res => res.data);
}

export async function deleteProject(payload) {
  return axios
    .delete('/model-folder', {
      params: {
        folderIds: payload,
      },
    })
    .then(res => res.data);
}

export async function getFolderInvitations(folderId) {
  return axios.get(`/model-folder/${folderId}/invitations`).catch(error => {
    console.error('Error fetching folder invitations:', error);
  });
}

export async function shareFolder(folderId, payload) {
  try {
    const response = await axios.post(
      `/model-folder/${folderId}/invite`,
      payload,
    );
    return response;
  } catch (error) {
    console.error('Error sharing folder:', error);
    throw error;
  }
}

export async function updateFolderInviteAccess(folderId, payload) {
  return axios
    .patch(`/model-folder/${folderId}/invite/update`, payload)
    .catch(error => {
      console.error('Error updating folder invite access:', error);
    });
}

export async function lockFolderAccess(folderId) {
  return axios.patch(`/model-folder/${folderId}/invite/lock`).catch(error => {
    console.error('Error updating folder access:', error);
  });
}

export async function revokeFolderInvite(folderId, payload) {
  return axios
    .delete(`/model-folder/${folderId}/invite/revoke`, { data: payload })
    .catch(error => {
      console.error('Error revoking folder invite:', error);
      throw error;
    });
}

export async function addFolderToOrganization(sourceFolderId, organizationId) {
  return axios
    .post(`/model-folder/${sourceFolderId}/org/${organizationId}`)
    .then(res => res.data);
}

// tasks
export async function deleteModelFromFolder(folderId, payload) {
  return axios
    .delete(`/model-folder/${folderId}/model`, {
      params: {
        cadFileIds: payload,
      },
    })
    .then(res => res.data);
}

export async function duplicateTask(payload) {
  return axios
    .post('/cad-file/duplicate', { cadFileIds: payload })
    .then(res => res.data);
}

export async function duplicateProject(payload) {
  return axios
    .post('/model-folder/duplicate', { folderIds: payload })
    .then(res => res.data);
}

export async function renameModel(cadFileId, payload) {
  return axios
    .put(`/cad-file/${cadFileId}/save`, payload)
    .then(res => res.data);
}

export async function saveTask(cadFileId, payload) {
  return axios
    .put(`/cad-file/${cadFileId}/save`, payload)
    .then(res => res.data);
}

export async function addCadFile(payload) {
  return axios.post('/cad-file/add', payload).then(res => res.data);
}

export async function addObjectToCadFile(payload) {
  return axios.post('/cad-object/add', payload).then(res => res.data);
}

export async function addModelToFolder(payload) {
  return axios.post('/model-folder/model', payload).then(res => res.data);
}

export async function addModelManualToFolder(scanningTypeID, payload) {
  return axios
    .post(`/reconstruction/model/upload/${scanningTypeID}`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => res.data);
}

export async function uploadVideoAsFrames(payload) {
  return axios.post('/video/add', payload).then(res => res.data);
}

export async function getPresignedUrl(scanningTypeID, type) {
  return axios
    .get(`/reconstruction/model/presign/${scanningTypeID}?type=${type}`)
    .then(res => res.data);
}

export async function getPresignedUrlChats(type) {
  return axios
    .get(`/reconstruction/image/presign/chat?type=${type}`)
    .then(res => res.data);
}

export async function addProject(payload) {
  return axios.post('/model-folder', payload).then(res => res.data);
}

export async function getTemplates() {
  return axios.get('/templates').then(res => res.data);
}

export async function getTemplateById(templateId) {
  return axios.get(`/templates/${templateId}`).then(res => res.data);
}

export async function moveModelToFolder(
  sourceFolderID,
  cadFileID,
  targetFolderID,
) {
  return axios
    .post(
      `/model-folder/${sourceFolderID}/model/${cadFileID}/${targetFolderID}`,
    )
    .then(res => res.data);
}

export async function updateRowOrderProject(folderId, payload) {
  return await axios
    .put(`/model-folder/${folderId}/rowOrder`, payload)
    .then(res => res.data);
}

export async function updateRowOrderTask(cadFileID, payload) {
  return await axios
    .put(`/cad-file/${cadFileID}/rowOrder`, payload)
    .then(res => res.data);
}
